<template>
    <span class="sendText">
        <b-btn class="font-weight-bold" :disabled="disabled" block :variant="disabled ? 'secondary' : 'warning'" @click="openModal">
            {{ buttonLabel }}
        </b-btn>
        <c-modal
            v-model="model"
            cancel-label="Never mind"
            centered size="md"
            title="Send Text To Customer"
            :tag="false"
            confirm-label="Send Text To Customer"
            :progressing="progressing"
            @submit="submit"
        >
            <template>
                <div>
                    <div
                        v-if="canViewCustomerPhone && hasCustomerPhone"
                        class="customer-phone-panel mb-3 p-3"
                    >
                        <div class="d-flex align-items-center">
                            <font-awesome-icon icon="phone" class="customer-phone-icon mr-2"/>
                            <div class="flex-grow-1 min-width-0">
                                <div class="customer-phone-label">CUSTOMER PHONE</div>
                                <div class="customer-phone-value">
                                    {{ showCustomerPhone ? formattedCustomerPhone : maskedCustomerPhone }}
                                </div>
                            </div>
                            <b-btn
                                size="sm"
                                variant="light"
                                class="customer-phone-toggle text-nowrap ml-2"
                                @click="showCustomerPhone = !showCustomerPhone"
                            >
                                <font-awesome-icon
                                    :icon="showCustomerPhone ? 'eye-slash' : 'eye'"
                                    class="align-middle mr-1"
                                />
                                {{ showCustomerPhone ? 'Hide' : 'Show' }}
                            </b-btn>
                        </div>
                    </div>
                    <p>Select a message to text to customer phone : </p>
                    <b-form-group>
                        <b-form-radio-group id="radio-group-send-text" v-validate="'required'" v-model="selectText" name="message">
                            <b-form-radio v-for="item in messages" :key="item.Text" class="my-3" :value="item.Text">{{item.Text}}</b-form-radio>
                            <b-form-radio class="my-3" value="Custom">Custom - Enter your own message</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group v-if="selectText === 'Custom'">
                <div class="text-right">
                    <span class="small text-right">100 Characters Max</span>
                </div>
                <b-textarea name="description" v-validate="validationTextArea" v-model="customText"/>
            </b-form-group>
                    <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
                <ul class="m-0 px-1">
                    <li v-for="err in errors.all()" :key="err">{{err}}</li>
                </ul>
            </b-alert>
                </div>
            </template>
        </c-modal>
    </span>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "sendTextOrder",
        components: {CModal},
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            messages: {
                type: Array,
                default: () => []
            },
            orderId: {
                required: true
            },
            buttonLabel: {
                type: String,
                default: 'Send Text To Customer'
            },
            customerPhone: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                model: false,
                progressing: false,
                selectText: null,
                customText: '',
                showCustomerPhone: false
            }
        },
        computed: {
            validationTextArea () {
                return this.selectText === 'Custom' ? {required: true, max: 100} : {required: false}
            },
            hasCustomerPhone () {
                return this.customerPhone && this.customerPhone.length > 0 && this.customerPhone.length < 15
            },
            canViewCustomerPhone () {
                const currentRole = Number(localStorage.getItem('ClientTypeID'))
                return currentRole === 6 || currentRole === 7
            },
            maskedCustomerPhone () {
                return '(•••) •••-••••'
            },
            formattedCustomerPhone () {
                return this.formatPhoneNumber(this.customerPhone)
            }
        },
        watch: {
            model (val) {
                if (!val) {
                    this.showCustomerPhone = false
                }
            }
        },
        methods: {
            openModal () {
                this.showCustomerPhone = false
                this.model = true
            },
            formatPhoneNumber (phone) {
                if (!phone) return ''
                let digits = phone.replace(/\D/g, '')
                if (digits.length === 11 && digits.startsWith('1')) {
                    digits = digits.substring(1)
                }
                return digits.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3')
            },
            submit () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        if (this.selectText === 'Custom') {
                            this.progressing = true
                            let data = {
                                RestaurantID: this.$store.state.selectedRestaurantId,
                                OrderID: this.orderId,
                                textMessage: this.customText
                            }
                            this.$api.getRestaurant.SendSMS(data).then(res => {
                                if (res.success) {
                                    this.progressing = false
                                    this.model = false
                                } else {
                                    this.$showError(res.message)
                                    this.progressing = false
                                }
                            })
                        } else {
                            let data = {
                                RestaurantID: this.$store.state.selectedRestaurantId,
                                OrderID: this.orderId,
                                textMessage: this.selectText
                            }
                            this.progressing = true
                            this.$api.getRestaurant.SendSMS(data).then(res => {
                                if (res.success) {
                                    this.progressing = false
                                    this.model = false
                                } else {
                                    this.$showError(res.message)
                                    this.progressing = false
                                }
                            })
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.customer-phone-panel {
    background-color: #f0f3f5;
    border-radius: 0.25rem;
}
.customer-phone-icon {
    color: #6c757d;
    font-size: 1.1rem;
}
.customer-phone-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #6c757d;
    margin-bottom: 0.15rem;
}
.customer-phone-value {
    font-size: 1.05rem;
    font-weight: 600;
    color: #212529;
    word-break: break-word;
}
.customer-phone-toggle {
    border: 1px solid #dee2e6;
    background: #fff;
}
</style>
